var map = {
	"./arrow-green.png": 739,
	"./arrow-white.png": 740,
	"./cake-two.png": 741,
	"./cake.png": 742,
	"./creeper-one.png": 743,
	"./creeper-two.png": 744,
	"./discord-banner.png": 745,
	"./dragon-one.png": 746,
	"./dragon-two.png": 747,
	"./facebook.png": 748,
	"./google.png": 749,
	"./guide-girl.png": 615,
	"./hero2.png": 750,
	"./heroes-one.png": 751,
	"./heroes-three.png": 752,
	"./heroes-two.png": 753,
	"./horse.png": 616,
	"./house.png": 754,
	"./icons/badge-orange.png": 755,
	"./icons/course-available.png": 617,
	"./icons/course-not-available.png": 618,
	"./icons/course-not-subscribed.png": 619,
	"./icons/emerald.png": 756,
	"./icons/medal.png": 620,
	"./icons/pickaxe-code.png": 621,
	"./icons/pickaxe-plain.png": 622,
	"./icons/pickaxe-scratch.png": 623,
	"./icons/pickaxe-snap-classic.png": 624,
	"./icons/pickaxe-snap.png": 625,
	"./icons/rub.png": 757,
	"./icons/sword-diamond.png": 626,
	"./icons/sword-iron.png": 627,
	"./icons/sword-wood.png": 628,
	"./kids.png": 758,
	"./landing/boy-head.png": 759,
	"./landing/boy.png": 760,
	"./landing/girl.png": 761,
	"./landing/kids.png": 762,
	"./landing/monitor.png": 763,
	"./landing/notebook.png": 764,
	"./landings/bg/code-bg.png": 765,
	"./landings/bg/code-gray-bg.png": 766,
	"./landings/bg/code-green-bg.png": 767,
	"./landings/bg/header_bg.png": 768,
	"./landings/bg/header_girl.png": 769,
	"./landings/bg/header_parent.png": 770,
	"./landings/bg/header_phrases.png": 771,
	"./landings/bg/minecraft-1.png": 772,
	"./landings/bg/minecraft-2.png": 773,
	"./landings/bg/minecraft-3.png": 774,
	"./landings/bg/quote-black.png": 775,
	"./landings/bg/what_left.png": 776,
	"./landings/bg/what_right.png": 777,
	"./landings/blocks/column.png": 778,
	"./landings/blocks/spawn.png": 779,
	"./landings/blocks/start.png": 780,
	"./landings/blocks/weather.png": 781,
	"./landings/boy-bg.png": 782,
	"./landings/boy-standing.png": 783,
	"./landings/boy.png": 784,
	"./landings/check.png": 785,
	"./landings/cube.png": 786,
	"./landings/girl.png": 787,
	"./landings/heart.png": 788,
	"./landings/hero-fighting.png": 789,
	"./landings/hero-standing.png": 790,
	"./landings/icon-0.png": 791,
	"./landings/icon-1.png": 792,
	"./landings/icon-2.png": 793,
	"./landings/icon-3.png": 794,
	"./landings/logo-grayscale.png": 504,
	"./landings/logo-parents.png": 612,
	"./landings/logo.png": 503,
	"./landings/minus.png": 795,
	"./landings/quote.png": 796,
	"./landings/snap-example.png": 797,
	"./landings/teacher-standing.png": 798,
	"./landings/tick.png": 799,
	"./logo-white.png": 800,
	"./mascot.png": 801,
	"./ml.png": 802,
	"./new/bg_minecraft-one.png": 803,
	"./new/bg_minecraft-sun0.png": 804,
	"./new/bg_minecraft-sun1.png": 805,
	"./new/bg_minecraft-two.png": 806,
	"./new/icon-1.png": 807,
	"./new/icon-2.png": 808,
	"./new/icon-3.png": 809,
	"./new/icon-4.png": 810,
	"./new/kid.png": 811,
	"./new/logo.png": 812,
	"./new/monitor-shadow.png": 813,
	"./new/monitor-shine.png": 814,
	"./new/monitor.png": 815,
	"./partners/codim.png": 816,
	"./partners/vikids.png": 817,
	"./pig.png": 818,
	"./pixels.png": 819,
	"./present.png": 820,
	"./python-big.png": 821,
	"./python.png": 613,
	"./python_old.png": 822,
	"./schools/2123_mskobr.png": 603,
	"./schools/26_mbou.png": 604,
	"./schools/kodini.png": 605,
	"./schools/metallurg.png": 606,
	"./schools/o-brain.png": 607,
	"./schools/qtime.png": 608,
	"./schools/qtime_estonia.png": 609,
	"./schools/robotorium.png": 610,
	"./snap-axe.png": 823,
	"./snap-big.png": 824,
	"./snap-pickaxe.png": 825,
	"./snap-shovel.png": 826,
	"./snap.png": 827,
	"./snap_old.png": 828,
	"./tinkercad.png": 240,
	"./tinkoff.png": 829,
	"./torch.png": 830,
	"./tree-two.png": 831,
	"./tree.png": 832,
	"./vk.png": 833
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 614;